import React, { useEffect, useState } from "react";
import { Space, Table, Input, Button, Modal, Select, Form, Tag } from "antd";
import { Box, styled, Typography } from "@mui/material";
import { useAxios } from "../../contexts/AxiosProvider";
import { InstrumentApi } from "../../services/InstrumentApi";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router";
import UtcMinusFour from "../../utils/UtcMinusFour";
import { DomainApi } from "../../services/DomainApi";
import { ClientApi } from "../../services/ClientApi";

const { Search } = Input;
const { Option } = Select;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 8,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 8,
  },
};

const InstrumentContainer = styled(Box)(({ openDrawer }) => ({
  // position: "relative",
  marginLeft: openDrawer ? 240 : 80,
  // backgroundColor: "#f8f8ff",
  width: openDrawer ? "calc(100% - 255px)" : "calc(100% - 85px)",
  // border: openDrawer ? "2px solid green" : "2px solid blue",
  height: "calc(100vh - 70px)",
}));

const SearchAndFilter = styled(Box)(() => ({
  display: "flex",
  margin: "20px 20px",
  flexDirection: "row",
  justifyContent: "space-between",
}));

const Instrument = ({ openDrawer, userData }) => {
  const axios = useAxios();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [instrumentData, setInstrumentData] = useState([]);
  const [DomainData, setDomainData] = useState({
    domainList: [],
    totalDomains: 0,
  });

  const [clientData, setClientData] = useState({
    clientList: [],
    totalClients: 0,
  });

  const [InstrumentAddData, setInstrumentAddData] = useState({
    instrument_name: "",
    file_type: "",
    domain_name: "",
    client_name: "",
    user_id: userData.userId,
    username: userData.username,
  });

  const [loading, setloading] = useState(false);
  const [isAddInstrumentModalOpen, setIsAddInstrumentModalOpen] =
    useState(false);

  const [pagination, setpagiNation] = useState({
    pageSize: 10,
    pageNo: 1,
    total: 0,
  });

  const handlePagination = (page, pageSize) => {
    setpagiNation({ ...pagination, pageNo: page, pageSize: pageSize });
  };

  const showAddInstrumentModal = () => {
    setIsAddInstrumentModalOpen(true);
  };

  const RenderEachInstrumentComponent = (record) => {
    navigate(
      `/dep/instrument/${record.instrument_id}/${record.instrument_name}`,
      {
        state: {
          ...userData,
        },
      }
    );
  };

  const handleCloseModal = () => {
    setIsAddInstrumentModalOpen(false);
    form.resetFields();
    setInstrumentAddData({
      instrument_name: "",
      file_type: "",
      domain_name: "",
      client_name: "",
      user_id: userData.userId,
      username: userData.username,
    });
  };

  const handleAddInstrumentChange = (value, name) => {
    if (name === "domain_name") {
      setInstrumentAddData((prev) => ({
        ...prev,
        domain_name: value,
        client_name: "",
      }));
      form.setFieldsValue({ client_name: "" });
    } else {
      setInstrumentAddData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleAddInstrument = async () => {
    const alphanumericWithLetter = /^(?=.*[a-zA-Z])[a-zA-Z0-9_ ]+$/;
    if (!alphanumericWithLetter.test(InstrumentAddData.instrument_name)) {
      enqueueSnackbar("Instrument name should contain letters!!", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return;
    }
    // const domain = DomainData.domainList.filter(
    //   (ele) => ele.domain_name === InstrumentAddData.domain_name
    // );

    const matchedDomain = DomainData.domainList.find(
      (ele) => ele.domain_name === InstrumentAddData.domain_name
    );

    const matchedClient = clientData.clientList.find(
      (ele) => ele.client_name === InstrumentAddData.client_name
    );

    if (!matchedDomain) {
      enqueueSnackbar("Invalid domain selected", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return;
    }

    try {
      const data = {
        user_id: InstrumentAddData.user_id,
        username: InstrumentAddData.username,
        instrument_name: InstrumentAddData.instrument_name,
        // domain_id: domain[0].domain_id,
        domain_id: matchedDomain.domain_id,
        client_id: matchedClient.client_id,
        file_type: InstrumentAddData.file_type,
      };
      const response = await InstrumentApi.createInstrument(axios, data);
      if (response.status === 201) {
        enqueueSnackbar("Instrument Added Successfully", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        fetchAllInstruments();
        setInstrumentAddData({
          instrument_name: "",
          file_type: "",
          domain_name: "",
          client_name: "",
          user_id: userData.userId,
          username: userData.username,
        });
        setIsAddInstrumentModalOpen(false);
        onReset();
      }
    } catch (error) {
      if (error.response.status === 409) {
        enqueueSnackbar("Instrument Name Already Exists", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        fetchAllInstruments();
      } else {
        console.error("Error adding Instrument:", error);
        enqueueSnackbar("Unexpected Error Adding Instrument", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        onReset();
      }
    }
  };

  const InstrumentColumns = [
    {
      title: "Function Name",
      dataIndex: "domain_name",
      key: "domain_name",
      render: (_, { domain_name }) => (
        <>
          <Tag

             style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              textAlign: "center",
            }}
          
            color={
              domain_name === "Technical Operations"
                ? "green"
                : domain_name === "Translational Research"
                ? "red"
                : "yellow"
            }
            key={domain_name}
          >
            {domain_name}
          </Tag>
        </>
      ),
    },
    {
      title: "Sub-Function Name",
      dataIndex: "client_name",
      key: "client_name",
      render: (_, { client_name }) => (
        <>
          {/* <Tag key={client_name}>{client_name}</Tag> */}
          <Tag
            key={client_name}
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              textAlign: "center",
            }}
          >
            {client_name}
          </Tag>
        </>
      ),
    },
    {
      title: "Data Source Name",
      dataIndex: "instrument_name",
      key: "instrument_name",
      onCell: (record) => {
        return {
          onClick: () => {
            RenderEachInstrumentComponent(record); // Call openDrawer function here or pass any necessary data to Engagement component
          },
        };
      },
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Creation Date",
      dataIndex: "creation_date",
      key: "creation_date",
      render: (text, record) => {
        const utcMinusFour = new UtcMinusFour(new Date(record.creation_date));
        return (
          <Typography variant="body1" gutterBottom sx={{ color: "#00043C" }}>
            {utcMinusFour.formatUtcMinusFour("yyyy-MM-dd hh:mm a")}
          </Typography>
        );
      },
    },
    {
      title: "File Type",
      dataIndex: "file_type",
      key: "file_type",
      render: (text) => <p>.{text}</p>,
    },
    {
      title: "Action",
      key: "action",
      onCell: (record) => {
        return {
          onClick: () => {
            showDeleteConfirm(record);
          },
        };
      },
      render: (_, record) => (
        <Space size="middle">
          <a>Delete</a>
        </Space>
      ),
    },
  ];

  const showDeleteConfirm = (record) => {
    Modal.confirm({
      title: "Are you sure you want to delete this Data Source ?",
      content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => deleteInstrument(record),
    });
  };

  const deleteInstrument = async (record) => {
    try {
      const response = await InstrumentApi.deleteInstrument(
        axios,
        record.instrument_id
      );
      if (response.status === 200) {
        enqueueSnackbar(`${record.instrument_name} deleted successfully`, {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        fetchAllInstruments();
      } else if (response.status === 400) {
        enqueueSnackbar(
          `${record.instrument_name} is linked with a Data Processor. Delete the associated data processor first.`,
          {
            variant: "error",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          }
        );
        fetchAllInstruments();
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 401) {
          // Handle unauthorized error
        } else {
          enqueueSnackbar(`Error: ${error.response.data}`, {
            variant: "error",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        }
      } else {
        enqueueSnackbar(`Error: ${error.message}`, {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    }
  };

  const fetchAllInstruments = async (search, searchParam) => {
    try {
      setloading(true);
      const data = {
        user_id: userData.userId, // Provide the user_id
        search: search, // Set search to true if searchParam is provided
        searchParam: searchParam, // Pass searchParam
        pageNumber: pagination.pageNo,
        pageSize: pagination.pageSize,
      };
      const response = await InstrumentApi.getAllInstruments(axios, data);
      if (response.status === 200) {
        setInstrumentData(response.data.instrumentList);
        setpagiNation((prev) => ({
          ...prev,
          total: response.data.totalCount,
        }));
      }
    } catch (error) {
      enqueueSnackbar("Internal Server Error!", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } finally {
      setloading(false);
    }
  };

  const onSearch = async (value, _e, info) => {
    console.log("onSearch", value);
    fetchAllInstruments(true, value);
    setpagiNation((prev) => ({ ...prev, pageNo: 1 }));
  };

  useEffect(() => {
    fetchAllInstruments(false, "");
  }, []);

  const fetchAllDomains = async () => {
    try {
      setloading(true);
      const data = {
        user_id: userData.userId,
        search: false,
        domainSearchParam: "",
        pageNumber: 0,
        pageSize: 0,
      };
      const response = await DomainApi.getAllDomains(axios, data);
      if (response.status === 200) {
        console.log("DomainData", response.data);
        setDomainData(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setloading(false);
    }
  };

  const fetchAllClients = async (domain_id) => {
    try {
      setloading(true);
      const data = {
        user_id: userData.userId,
        domain: true,
        domain_id: domain_id,
        search: false,
        searchParam: "",
        pageNumber: 0,
        pageSize: 0,
      };
      const response = await ClientApi.getAllClients(axios, data);
      if (response.status === 200) {
        setClientData(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setloading(false);
    }
  };

  // useEffect(() => {
  //   if (InstrumentAddData.domainList[0].domain_id) {
  //     fetchAllClients(InstrumentAddData.domainList[0].domain_id);
  //   }
  // }, [InstrumentAddData.domainList[0].domain_id]);

  useEffect(() => {
    fetchAllInstruments(false, "");
  }, [pagination.pageNo, pagination.pageSize]);

  useEffect(() => {
    const matchedDomain = DomainData.domainList.find(
      (ele) => ele.domain_name === InstrumentAddData.domain_name
    );
    if (matchedDomain?.domain_id) {
      fetchAllClients(matchedDomain.domain_id);
    }
  }, [InstrumentAddData.domain_name, DomainData.domainList]);

  useEffect(() => {
    if (isAddInstrumentModalOpen) {
      fetchAllDomains();
    }
  }, [isAddInstrumentModalOpen]);

  const onReset = () => {
    form.resetFields();
    setInstrumentAddData({
      instrument_name: "",
      file_type: "",
      domain_name: "",
      client_name: "",
      user_id: userData.userId,
      username: userData.username,
    });
  };

  return (
    <InstrumentContainer openDrawer={openDrawer}>
      <SearchAndFilter>
        <Search
          placeholder="Search Data Source"
          enterButton
          size="large"
          allowClear
          onSearch={onSearch}
          style={{ width: "20%" }}
        />
        <Button type="primary" size="large" onClick={showAddInstrumentModal}>
          Add Data Source
        </Button>
      </SearchAndFilter>
      <div
        style={{
          width: "100%",
          maxHeight: "85%",
          overflowY: "auto",
        }}
      >
        <Table
          bordered
          columns={InstrumentColumns}
          style={{ fontWeight: "640", margin: "20px" }}
          dataSource={instrumentData}
          sticky
          pagination={{
            current: pagination.pageNo,
            pageSize: pagination.pageSize,
            total: pagination.total,
            onChange: handlePagination,
          }}
          loading={loading}
        />
      </div>

      {isAddInstrumentModalOpen && (
        <Modal
          title="Add Data Source"
          visible={isAddInstrumentModalOpen}
          onCancel={handleCloseModal}
          footer={null}
        >
          <Form
            {...layout}
            form={form}
            name="control-hooks"
            onFinish={handleAddInstrument}
            style={{
              maxWidth: 600,
            }}
          >
            <Form.Item
              name="domain_name"
              label="Function Name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                value={InstrumentAddData.domain_name}
                size="large"
                onChange={(value) =>
                  handleAddInstrumentChange(value, "domain_name")
                }
                placeholder="Select Function"
                style={{
                  width: "100%",
                }}
              >
                {DomainData.domainList &&
                  DomainData.domainList.map((domain) => {
                    return (
                      <Option value={domain.domain_name}>
                        {domain.domain_name}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            {InstrumentAddData.domain_name && (
              <Form.Item
                name="client_name"
                label="Sub-Function Name"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  value={InstrumentAddData.domain_name}
                  size="large"
                  onChange={(value) =>
                    handleAddInstrumentChange(value, "client_name")
                  }
                  placeholder="Select Sub-Function"
                  style={{
                    width: "100%",
                  }}
                >
                  {clientData.clientList &&
                    clientData.clientList.map((client) => {
                      return (
                        <Option value={client.client_name}>
                          {client.client_name}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            )}
            <Form.Item
              name="instrument_name"
              label="Data Source Name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input
                size="large"
                required
                id="instrument_name"
                name="instrument_name"
                autoComplete="instrument_name"
                value={InstrumentAddData.instrument_name}
                onChange={(e) =>
                  handleAddInstrumentChange(e.target.value, "instrument_name")
                }
              />
            </Form.Item>
            <Form.Item
              name="file_type"
              label="File Type"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                value={InstrumentAddData.file_type}
                size="large"
                onChange={(value) =>
                  handleAddInstrumentChange(value, "file_type")
                }
                placeholder="Select file type"
                style={{
                  width: "100%",
                }}
              >
                <Option value="csv">.csv</Option>
                <Option value="txt">.txt</Option>
                <Option value="xlsx">.xlsx</Option>
                <Option value="json">.json</Option>
                <Option value="avro">.avro</Option>
              </Select>
            </Form.Item>
            <Form.Item {...tailLayout}>
              <Space>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
                <Button htmlType="button" onClick={onReset}>
                  Reset
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      )}
    </InstrumentContainer>
  );
};

export default Instrument;
